import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton } from '../common/Buttons';

import Image1 from '../images/social-media.png';
import Image2 from '../images/research.png';
import Image3 from '../images/users.png';
import Image4 from '../images/support.png';

import './style.css';

const highlights = [
  {
    image: Image1,
    title: 'Social Media',
    subtitle: 'Marketing',
  },
  {
    image: Image2,
    title: '100%',
    subtitle: 'Research before use',
  },
  {
    image: Image3,
    title: 'Internet User',
    subtitle: '4.9 Billion',
  },
  {
    image: Image4,
    title: '24/7',
    subtitle: 'Support & Monitoring',
  },
];

function WhyChooseUsSection() {
  return (
    <section
      id="why-choose-us"
      className="whychoose-section"
    >
      <Container>
        <Row className="align-items-center">
          <Col md="6">
            <Row>
              {highlights.map(({ image, title, subtitle }, index) => (
                <Col xs="6" className="mb-3" key={index}>
                  <div
                    className="highlight-block"
                    style={{
                      backgroundImage: `url(${image})`,
                    }}
                  >
                    <div className="highlight-gradient" />
                    <div className="highlight-content">
                      <h6 className="fw-bold mb-1">{title}</h6>
                      <div className="highlight-subtitle">{subtitle}</div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
          <Col md="6">
            <div className="mb-5">
              <h2 className="fw-bold mb-2 whychoose-title">
                Why Choose Us?
              </h2>
              <div className="whychoose-lead">
                We’re not just another agency.
              </div>
            </div>
            <div className="whychoose-desc">
              With{' '}
              <span className="whychoose-highlight">
                over 10 years of experience
              </span>{' '}
              and 5,000+ successful projects delivered, we bring deep expertise in AI, web development, and digital strategy. Backed by a skilled team and 24/7 personalized support, we don’t offer one-size-fits-all solutions — we adapt to your business, your goals, and your vision.
            </div>
            <PrimaryButton href="/whoweare">Learn More</PrimaryButton>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WhyChooseUsSection;
